<template>
  <!-- ORDER BAR -->
  <div>
    <div :class="[isOrderActive ? 'is-active' : '', 'dropdown']">
      <div class="dropdown-trigger is-vertical-center is-size-7">
        <button
          class="button is-small"
          aria-haspopup="true"
          aria-controls="dropdown-menu"
          @click.stop.prevent="isOrderActive = !isOrderActive"
        >
          <span class="is-size-7">Ordine</span>
          <span class="icon is-small">
            <img src="images/down.png" />
          </span>
        </button>
        <span class="icon is-small">
          <img
            :src="[
              activeOrderDir === 1
                ? 'images/icon_sort_down.png'
                : 'images/icon_sort_up.png',
            ]"
            @click.prevent="handleOrderDir"
          />
        </span>
        {{ orderEl[activeOrderItem].name }}
      </div>
      <div id="dropdown-menu" class="dropdown-menu" role="menu">
        <div class="dropdown-content">
          <ul>
            <li
              v-for="item in orderEl"
              :key="item.id"
              @click="handleOrderMenu(item)"
            >
              <a
                :class="[
                  item.id == item.id ? 'is-active' : '',
                  'dropdown-item',
                ]"
                @click.prevent="handleOrderMenu(item)"
              >
                {{ item.name }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- FINE ORDER BAR -->
</template>
<script>
import { ServiceBus } from '../../ServiceBus.js'
export default {
  name: 'OrderBar',
  props: {
    orderEl: {
      default: new Array(),
      type: Array,
    },
    orderDir: {
      default: 0,
      type: Number,
    },
    orderActive: {
      default: 0,
      type: Number,
    },
    id: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      isOrderActive: false,
      activeOrderDir: 1,
      activeOrderItem: 0,
    }
  },
  mounted() {
    this.$nextTick(function () {
      const vm = this
      vm.activeOrderDir = vm.orderDir
      vm.activeOrderItem = vm.orderActive
    })
  },
  methods: {
    handleOrderMenu(item) {
      const vm = this
      vm.activeOrderItem = item.id
      vm.isOrderActive = false
      vm.emitChange()
    },
    handleOrderDir() {
      const vm = this
      if (vm.activeOrderDir === 1) {
        vm.activeOrderDir = 0
      } else {
        vm.activeOrderDir = 1
      }
      vm.emitChange()
    },
    emitChange() {
      const vm = this
      let obj = {}
      obj.id = vm.id
      obj.orderDir = vm.activeOrderDir
      obj.orderItem = vm.activeOrderItem
      ServiceBus.$emit('orderbar', obj)
    },
  },
}
</script>
